import React, { useState } from 'react';
import { Turl } from '../components/tUrl.js';
// ‼️ Убедитесь, что у вас есть CSS для нового класса 'license-selection'
import '../css/emailVerificationFlow.css';
import { t } from 'ttag';
import { formatNumberWithCommas } from '../components/formatIntegerWithCommas.js';

const tg = window.Telegram ? window.Telegram.WebApp : null;

// --- API Функции (адаптированы) ---
// (Бывшая sendTradeCode)
const sendLicenseCode = async (licenseId, amount) => {
    const _userData = tg ? tg.initData : null;
    let userData = {
        initData: _userData,
        amount: amount,
        licenseId: licenseId,
        type: 3 // 
    };

    const response = await fetch(Turl + '/st/send-trade-code', { // ‼️ Возможно, URL должен быть другим?
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userData),
    });
    return response.json();
};

// (Бывшая submitTradeDeposit)
const submitLicensePurchase = async (licenseId, amount, code) => {
    const _userData = tg ? tg.initData : null;
    let userData = {
        initData: _userData,
        code: code,
        amount: parseFloat(amount),
        licenseId: licenseId
    };

    // ‼️ Возможно, URL должен быть другим? (например, /st/buy-license)
    const response = await fetch(Turl + '/st/license-buy', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
    });
    return response.json();
};

// --- Компонент ---

const BuyLic = ({ recData }) => {
    // ‼️ НОВЫЙ ШАГ ПО УМОЛЧАНИЮ
    const [step, setStep] = useState('select_license'); // 'select_license', 'enter_code', 'confirmed'

    // ‼️ НОВОЕ СОСТОЯНИЕ ДЛЯ ВЫБРАННОЙ ЛИЦЕНЗИИ
    const [selectedLicense, setSelectedLicense] = useState(null);

    const [code, setCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    // ‼️ НОВЫЙ ОБРАБОТЧИК: вызывается при выборе лицензии
    const handleLicenseSelect = async (license) => {
        setIsLoading(true);
        setError('');
        setSelectedLicense(license); // Сохраняем выбранную лицензию

        const response = await sendLicenseCode(license.id, license.price);

        setIsLoading(false);
        if (response.success) {
            setStep('enter_code'); // Переходим к шагу ввода кода
        } else {
            setError(response.message || 'Не удалось отправить код. Попробуйте снова.');
            setSelectedLicense(null); // Сбрасываем выбор в случае ошибки
        }
    };

    // ‼️ ОБНОВЛЕННЫЙ ОБРАБОТЧИК: использует 'selectedLicense'
    const handleCodeSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        const response = await submitLicensePurchase(
            selectedLicense.id,
            selectedLicense.price,
            code
        );

        setIsLoading(false);
        if (response.success) {
            setStep('confirmed');
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } else {
            setError(response.message || 'Ошибка. Неверный код.');
        }
    };

    // --- Рендеринг в зависимости от текущего шага ---

    if (step === 'confirmed') {
        return (
            <div className="Email-block">
                <div>
                    <h2 style={{ color: '#4cdf4c' }}>✓ Successfully!</h2>
                    {/* ‼️ Обновленный текст */}
                    <p>Your <strong>{selectedLicense.name}</strong> license purchase for <strong>{selectedLicense.price} USDT</strong> is successful.</p>
                </div>
            </div>
        );
    }

    if (step === 'enter_code') {
        return (
            <div className="Email-block">
                <h2>Email Confirmation</h2>
                <p>
                    We sent a code to your registered email.<br />
                    {/* ‼️ Обновленный текст */}
                    You are purchasing: <strong>{selectedLicense.name}</strong> for <strong>{selectedLicense.price} USDT</strong>.
                </p>
                <form onSubmit={handleCodeSubmit}>
                    <div className='email-enter'>
                        <label htmlFor="code">Verification code:</label>
                        <input
                            type="text"
                            id="code"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            placeholder="123456"
                            required
                            disabled={isLoading}
                        />
                    </div>
                    <div className='email-enter'>
                        <button type="submit" disabled={isLoading || code.length < 6}>
                            {isLoading ? 'Checking...' : 'Confirm & Buy'}
                        </button>
                    </div>
                    {error && <p className="error-text">{error}</p>}
                    <button
                        type="button"
                        // ‼️ Возвращает на шаг выбора лицензии
                        onClick={() => { setStep('select_license'); setError(''); setSelectedLicense(null); }}
                        className="link-button"
                    >
                        Change license
                    </button>
                </form>
            </div>
        );
    }

    // --- Шаг 1: Выбор лицензии (Бывший 'enter_amount') ---
    return (
        <>
            {/* Блок Баланса */}
            <div className="f-balance-card">
                <div className="f-balance-label">{t`Balance`}</div>
                <div className="f-balance-value">{formatNumberWithCommas(recData.usdt, 0)} USDT</div>
            </div>

            <div className="Email-block">
                <h2>Select a license to purchase</h2>
                <p>We will send a confirmation code to your email.</p>

                {/* ‼️ НОВЫЙ БЛОК ВЫБОРА ЛИЦЕНЗИЙ */}
                <div className="license-selection">
                    {recData.lic_type && recData.lic_type.map(lic => {
                        const hasEnoughBalance = recData.usdt >= lic.price;
                        return (
                            <button
                                key={lic.id}
                                className="license-option-button"
                                onClick={() => handleLicenseSelect(lic)}
                                // Блокируем, если идет загрузка ИЛИ не хватает баланса
                                disabled={isLoading || !hasEnoughBalance}
                            >
                                <span className="license-name">{lic.name}</span>
                                <span className="license-price">{lic.price} USDT</span>
                                {!hasEnoughBalance && <span className="license-error"> (Not enough funds)</span>}
                            </button>
                        );
                    })}
                </div>
                {/* Конец блока выбора */}

                {error && <p className="error-text" style={{ marginTop: '15px' }}>{error}</p>}

                {/* Показываем спиннер загрузки внизу, если лицензия была выбрана */}
                {isLoading && selectedLicense && (
                    <div className='email-enter'>
                        <p>Sending code for {selectedLicense.name}...</p>
                        {/* Тут можно добавить компонент спиннера */}
                    </div>
                )}
            </div>
        </>
    );
};

export { BuyLic };